import { group, GroupedSeries } from '@d3fc/d3fc-group';
import { TimeSeriesChartDataItem } from 'utils/components/TimeSeriesChart/TimeSeriesChartData';

export function computeGroupedData<T extends TimeSeriesChartDataItem>(
    dataSeries: T[],
    mapToPartial: (d: T) => Partial<T>,
    barFieldOrder: (keyof T)[]
): GroupedSeries<Partial<T>>[] {
    if (dataSeries.length === 0) {
        return [];
    }

    const groupedData: GroupedSeries<Partial<T>>[] = group().key('time')(
        dataSeries.map(mapToPartial)
    );

    // order bars correctly
    return barFieldOrder.map((key) => {
        for (let x = 0; x < groupedData.length; ++x) {
            const item = groupedData[x];
            if (item.key === key) {
                return item;
            }
        }
        return {} as GroupedSeries<Partial<T>>;
    });
}
